import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Box,
  Breadcrumbs,
  Divider,
  Grid,
  Link,
  Tabs,
  Theme,
  Toolbar,
  Typography,
  IconButton,
  Container,
  Dialog,
} from '@mui/material';
import { v4 as uuid } from 'uuid'; 

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import { ViewModule, Dehaze,  } from '@mui/icons-material';
import ViewListIcon from '@mui/icons-material/ViewList';


import { Link as RouteLink, useHistory, useParams } from 'react-router-dom';
// import { searchAction } from '@ivymobi/orbit-core/business/tenant';
import { getDocumentThumb, getFileType, isWeiXin, SampleSendEvent } from '@ivymobi/orbit-core';
import Title from '../components/views/title';
import _, { isEmpty, isNull, pick } from 'lodash';

import { DeviceType, InnerUserContext, TenantContext, UserContext, WebSiteContext  } from '../orbit-context';
import './selections.css';

import { loginAction, sendLoginMobileCodeAction, useOptions } from '@ivymobi/orbit-core/business/user';
import { getOutLibDocumentsAction, searchAction, searchSolrAction, userShareEvent } from '@ivymobi/orbit-core/business/share';
import { DocumentGridCard } from '../documents/grid';
import PreviewDialog from '../documents/preview';

import SearchInput from './component/SearchInput';
import { PictureCard, DocumentGridList } from './component/grid';
import SearchPage from '../documents/SearchPage';
import { DownloadFile, getFileSuffix } from '@ivymobi/orbit-core';
import { getselLeadsInfoByphoneAction, getTenantsIsLeadsInfoByphoneAction } from '@ivymobi/orbit-core/business/stats';
import LoginForm from './component/loginForm';
import { LeadMustForm } from './component/leadform';
import { documentEventAction } from '@ivymobi/orbit-core/business/document';


const useStyles = makeStyles((theme: Theme) => createStyles({
  pages: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    alignItems: 'center'
  },
  sliderBar: {
    display: 'flex',
    flexDirection: 'column',
    width: '25%',
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(2)
  },
  content: {
    flexGrow: 1,
    flexBasis: 0,
    display: 'flex',
    // justifyContent:'center',
    alignItems: 'center',
    flexDirection: 'column',
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(2)
  },


}));

const queryParse = (query) => {
  query = query.substring(query.indexOf('?') + 1);
  const array = query.split('&');
  const params = {};
  array.forEach(item => {
    const key = item.substring(0, item.indexOf('='));
    const value = decodeURIComponent(item.substring(item.indexOf('=') + 1));
    params[key] = value;
  });
  return params;
};



function FileDocument(props) {
  const {
    document, onClose, onLikeFormOpen, share, user, handleDownload, eventID
  } = props;
  if (!document) {
    return null;
  }
  const { asset } = document;
  const dispatch = useDispatch();
  // file type
  const isFile = document.type === 'file';
  const fileType = isFile && getFileType(document.name);

  const isPreview = false;

  const onLeft = (e) => {
    console.log(e);
  };
  const onRight = () => {
    const anchor = window.document.createElement('a');
    const body = window.document.querySelector('body');
    anchor.href = asset.url;
    anchor.download = document.name;
    anchor.style.display = 'none';
    body.appendChild(anchor);
    anchor.click();
    body.removeChild(anchor);
    window.URL.revokeObjectURL(anchor.href);
  };
  return (
    <Box style={{ backgroundColor: '#2F3941', height: '100%' }}>
      <PreviewDialog eventID={eventID} handleSendToEmail={() => {console.log('--------');}} type='share' handleDownload={handleDownload} user={user} document={document} onClose={onClose} share={share} isPreview={isPreview} onLikeFormOpen={onLikeFormOpen} />
      {/* <Toolbar /> */}
      {fileType !== 'pdf' && <Toolbar />}
      {/* {fileType !== 'pdf' && <Toolbar 
        style={{
          position: 'fixed',  bottom: 0,
          width: '100%',
          display: 'flex', justifyContent: 'center'
        }}>
        <Button variant='contained'
          style={{ borderRadius: '16px', backgroundColor: '#39AC4A', color: 'white' }}
          onClick={onLikeFormOpen}
        >
          我感兴趣，请联系我
        </Button>

      </Toolbar>} */}
    </Box>
  );
}

export const FileDownloadView = (props) => {
  const {doLogin} = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams<any>() ?? { id: null };
  const deviceType = useContext(DeviceType);
  const params = queryParse(location.search);
  const classes = useStyles();
  const {user, token} = useContext(UserContext);
  const webContext = useContext(WebSiteContext);

  const { webInfo, language, acl } = webContext;
  const [useLoading, setUseLoading] = useState(false);
  const [documents, setDocuments] = useState({});
  const [data, setData] = useState([]);
  const [firstDocs, setFirstDocs] = useState([]);
  const [viewMode, setViewMode] = useState('picture');
  const [searching, setSearching] = useState(false);
  const [searchList, setSearchList] = useState({folder: [], doc: [], highlighting: []});
  const [routers, setRouters] = useState([]);
  const [title, setTitle] = useState('');
  const [selectDoc, setSelectDoc] = useState(null);
  const innerUser = useContext(InnerUserContext);
  const [isLogining, setIsLogining] = useState(false);
  const [leadProfile, setLeadProfile] = useState({});
  const [mustShow, setMustShow] = useState(false);
  let [eventID, setEventID] = useState(null);  // 埋点事件创建ID

  const handleSendCode = (phone, countryCode) => {
    return dispatch(sendLoginMobileCodeAction({ mobile: phone, countryCode }));
  };

  const handleCloseLogin = () => {
    if ((isEmpty(user) || !user)&&documents[id]?.type==='file'&&acl.eoi.includes('view'))
    {
      if (isWeiXin()&&  history.length<=1) {
        history.replace('/');
        return; 
      }
  
      history.goBack();
    }
    setIsLogining(false);
    // setLoginMode('');
    // setLoginMode('normal');
  };
  // 登录方法
  const handleAuth = async (data) => {
    // ------------------------方法重写----------------------
    // setMode('normal');
    const payload = Object.assign({}, data, pick(user, ['countryCode', 'phone']));
    const res = await dispatch(loginAction(payload)).catch(e => {
      console.error(e);
    });

    const res1 = await dispatch(getTenantsIsLeadsInfoByphoneAction({ tenant:{id:webInfo.tnt_id}, user:res, phone:res.user.phone}));
    doLogin(res);
    setIsLogining(false);
    let show = false;
    if (documents[id]?.type==='file') {
      show = (!res1.data);
      setMustShow(show);
    } else {
      show = (!res1.data) && (acl?.eoi?.includes('download')||acl?.eoi?.includes('view'));
      setMustShow(show);
    }
    // if(webInfo?.tnt_id==='-e5127588-684c-40de-8d16-6ee235e09b18'&&(!show)){

    //   if(!await checkECodeState()){
    //     setShowECode(true)
    //     return;
    //   }
    // }
    // if (acl.eoi.includes("download")) {

    // }
    return res;
  };
    // 输入信息可继续后 profile值
  const handleAuthAndShareEvent = async (data) => {
    const payload = Object.assign({}, data, pick(user, ['countryCode', 'phone']));
    // const process = user.token
    //   ? sendEvent('like', currentDocument, payload)
    //   : dispatch(loginAction(payload))
    //   .then(res => {
    //     onLogin(res);
    //     return res;
    //   });
    // return process.then(
    //   () => { setMode('normal'); setLeadProfile(payload); },
    //   (e) => console.error(e),
    // );
    let res;
    if (token) {
      await sendEvent('view', documents[id], payload);     
    } else {
      res = await dispatch(loginAction(payload));
      doLogin(res);
    }
  
    setMustShow(false);
    setLeadProfile(payload);
  };
    // 埋点事件
  const sendEvent = (type, document, detail = null, eventID = null) => {
    return SampleSendEvent(dispatch, userShareEvent, type, document, detail, eventID, innerUser?.userId?{id:innerUser?.userId}:user, {id:webInfo.tnt_id}, innerUser?.memberId);
  };
  const findPath = (dispatch, path, documents) => {
    const [docId] = path;
    const doc = documents[docId];
    if (!doc) {
      dispatch(getOutLibDocumentsAction({ tenantId: webInfo?.tnt_id, id: docId })).then(res => {
        const _docs = prev => res.reduce((acc, item) => {
          let id = '';
          if (item.type === 'catalog' || item.type === 'product') {
            id = item.realId;
          } else {
            id = item.id;
          }

          acc[id] = item;
          return acc;
        }, { ...prev });
        setDocuments(_docs);
      });
      return path;
    }
    const parentId = doc.parents?.[0];
    if (!parentId) {
      return path;
    }
    for (let i = 0; i < firstDocs.length; i++) {
      if (firstDocs[i] === doc.id) {
        return path;
      }
    }
    return findPath(dispatch, [parentId, ...path], documents);
  };

  const getLeadsInfo = useCallback(async() => {
    if (documents[id]?.type!='file') {
      return;
    }
    const res1 = await dispatch(getTenantsIsLeadsInfoByphoneAction({ tenant: {id:webInfo.tnt_id}, user:{user, token}, phone: user.phone}));
    // 第一行： 有user信息且已经登录并且设置了下载需要填写访客信息，都通过为true  有不通过的执行下一条
    // 24.1.6   这里的判断逻辑有问题，第一行验证通过直接为true，必会弹框， 加了!res1.data后与预期相同，但是没完整测试过
    const show = user  &&(!res1.data) && (acl?.eoi?.includes('view')); 
    setMustShow(show);
  }, [webContext, user, token, isLogining, acl, documents, id, leadProfile ]);
  useEffect(() => {
    if (innerUser.userId)
      return;
    if ( !id || !webInfo||!user || !documents[id]) {
      return;
    }
    getLeadsInfo();
  }, [user, webContext, dispatch, id, documents, webInfo]);
  useEffect(() => {
    console.log('---------------------------------------------');
    dispatch(getselLeadsInfoByphoneAction({ tenant:{id:webInfo.tnt_id}, user:{user, token}, phone:user?.phone})).then(res2 => {
      const leadp = _.get(res2, ['data', 'leads_profile'], {});
      setLeadProfile(leadp);
    });
  }, [webContext, user]);
  useEffect(() => {
    if ((!user)&&acl?.visitor_info?.length>0&&acl?.eoi.includes('view')&&documents[id]?.type==='file') {
      setIsLogining(true);
    }
  }, [acl, id, user, documents]);
  useEffect(() => {
    if (_.isNil(params.title)) return;
    params.title !== title ? setTitle(params.title) : '';
  }, [params]);
  useEffect(() => {
    console.log('打开了新页面打开了新页面打开了新页面打开了新页面');
    // 当监听到打开新页面时  执行一次取消搜索事件
    doCancel();

  }, [title]);

  const getEventID = () => {
    eventID = eventID??uuid();
    console.log('eventid========================', eventID);
    return eventID;
  };

  useEffect(() => {
    if (!webInfo?.tnt_id)
      return;
    setUseLoading(true);
    // setDocuments([])
    if (id) {
     
      dispatch(getOutLibDocumentsAction({ tenantId: webInfo?.tnt_id, id: id }))
      .then((res) => {
        const docs = [];
        for (let i = 0; i < res.length; i++) {
          docs.push(res[i].id);
          if (res[i].id===id && res[i].type==='file') {
            let createId = null;
            if (getFileType(res[i]?.asset?.name??' ')==='pdf') {
              createId = uuid();
              setEventID(createId);
            }
            
            
            sendEvent('view', res[i], null, createId);
            // dispatch(userShareEvent({user:{user:{id:innerUser?.userId??user?.id}}, share:{tenantId:webInfo.tnt_id,id:'11111111-1111-1111-1111-111111111111',memberId:innerUser?.memberId}, document:{id:id,type:'file'}, type:'view', detail:null})) 
          }
        }
        if (!documents[id])
          setFirstDocs(docs);
        setDocuments(prev => res.reduce((acc, item) => {
          let id = '';
          if (item.type === 'catalog' || item.type === 'product') {
            id = item.realId;
          } else {
            id = item.id;
          }

          acc[id] = item;
          return acc;
        }, { ...prev }));
        setUseLoading(false);
      });
    } else {
      dispatch(getOutLibDocumentsAction({ tenantId: webInfo?.tnt_id, id: null, type: 'allData' }))
      .then((res) => {
        if (!id) {
          const docs = [];
          for (let i = 0; i < res.length; i++) {
            docs.push(res[i].id);
          }
          setFirstDocs(docs);
        }
        setDocuments(prev => res.reduce((acc, item) => {
          let id = '';
          if (item.type === 'catalog' || item.type === 'product') {
            id = item.realId;
          } else {
            id = item.id;
          }

          acc[id] = item;
          return acc;
        }, { ...prev }));
        setUseLoading(false);
      });
    }
  }, [dispatch, id, setDocuments, webInfo]);
  // let routers = [];
  // if (documents[id]) {
  //   routers = findPath(dispatch, [id], documents);
  // }
  useEffect(() => {
    if (documents[id]) {
      setRouters(findPath(dispatch, [id], documents));
    }
    console.log('documents[id]====', documents, id);

  }, [documents]);

  useEffect(() => {
    // props.setTitle("行业应用案例")
    const ps = [];
    let last = null;
    if (routers.length > 0)
      ps.push({ to: '/assets', name: '资料下载' });
    for (let i = 0; i < routers.length; i++) {
      if (i == (routers.length - 1)) {
        last = { to: `/assets/${routers[i]}`, name: documents[routers[i]].name };
      }
      else {
        ps.push({ to: `/assets/${routers[i]}`, name: documents[routers[i]].name });
      }
    }
    console.log('ps====', ps);

    props.setParents(ps);
    props.setTitle(last?.name ?? '资料下载');

  }, [id]);
  useEffect(() => {

    if (documents[id]?.type !== 'file' && documents[id]?.type !== 'weblink') {
      const data = ((documents[id] ? (documents[id].documents ? documents[id].documents : []) : firstDocs)).map(id => documents[id])
      .filter(i => {
        return i;
      })
      .map(doc => ({
        ...doc,
        id: doc.id, name: doc.name, type: doc.type, acl: doc.acl, realId: doc.realId,
        thumbnail: getDocumentThumb(doc), link: `/assets/${doc.id}`
      }));
      const filterReadableArray = _.filter(data, (o) => {
        const readableList = _.get(o, ['acl', 'readable'], []);
        return readableList.length < 1;
      });
      setData(filterReadableArray);
    }

  }, [documents, id, firstDocs, dispatch]);

  // 搜索框 取消事件
  const [bSearch, setBSearch] = useState(false);
  const doCancel = () => {
    setBSearch(false);
  };
  const doDownload = (doc) => {
    console.log('dodownlaod===================================');
    setSelectDoc(doc);
    if (innerUser?.userId) {
      // dispatch(userShareEvent({user:{user:innerUser?.userId?{id:innerUser?.userId}:user}, share:{tenantId:webInfo?.tnt_id, id:'11111111-1111-1111-1111-111111111111', memberId:innerUser?.memberId}, document:doc, type:'download', detail:null}));
      sendEvent('download', doc);
      DownloadFile(doc.asset.url, doc.name+getFileSuffix(doc.name, doc?.asset?.name), window, dispatch);
      return ;
    }
    if ((!user)&&acl?.visitor_info?.length>0&&(acl?.eoi.includes('download')||acl?.eoi.includes('view'))) {
      setIsLogining(true);
      return ;
    }
    if (user) {
      dispatch(getTenantsIsLeadsInfoByphoneAction({ tenant:{id:webInfo.tnt_id}, user:{user, token}, phone:user?.phone})).then( async res1 => {
        if ((!res1.data) && (acl?.eoi?.includes('download')||acl?.eoi?.includes('view'))) {
          setMustShow((!res1.data) && (acl?.eoi?.includes('download')||acl?.eoi?.includes('view')));
          return;
        }
        // dispatch(userShareEvent({user:{user:innerUser?.userId?{id:innerUser?.userId}:user}, share:{tenantId:webInfo?.tnt_id, id:'11111111-1111-1111-1111-111111111111', memberId:innerUser?.memberId}, document:doc, type:'download', detail:null}));
        // SampleSendEvent(dispatch,userShareEvent,'download',doc,null,getEventID(),innerUser?.userId?{id:innerUser?.userId}:user,{id:webInfo.tnt_id},innerUser?.memberId)
        sendEvent('download', doc);
        DownloadFile(doc.asset.url, doc.name+getFileSuffix(doc.name, doc?.asset?.name), window, dispatch);
        return;
      });
    } 

    if (!user&&!acl?.eoi?.includes('download')) {
      // dispatch(userShareEvent({user:{user:innerUser?.userId?{id:innerUser?.userId}:user}, share:{tenantId:webInfo?.tnt_id, id:'11111111-1111-1111-1111-111111111111', memberId:innerUser?.memberId}, document:doc, type:'download', detail:null}));
      // SampleSendEvent(dispatch,userShareEvent,'download',doc,null,getEventID(),innerUser?.userId?{id:innerUser?.userId}:user,{id:webInfo.tnt_id},innerUser?.memberId)
      sendEvent('download', doc);
      DownloadFile(doc.asset.url, doc.name+getFileSuffix(doc.name, doc?.asset?.name), window, dispatch);
    }
  };
  const doSearch = (name) => {
    setBSearch(name.length !== 0);
    setSearching(true);
    return dispatch(
      searchSolrAction({ 
        tenant: {id: webInfo?.tnt_id}, 
        payload: {
          namefiter: name, 
          type: 0, 
          // title: params.title
        } 
      })
    )
    .then((res) => {
      // _.filter 过滤方法，acl中有readable，且长度大于0时，智能样本不显示
      const cloneObj = {
        // folder: _.get(res, ['folder'], []),
        doc: _.filter(_.get(res, ['doc'], []), (o) => {
          const readableList = _.get(o, ['acl', 'readable'], []);
          return readableList.length < 1;
        }),
        // highlighting: _.get(res, ['highlighting'], []),

        folder: _.filter(_.get(res, ['folder'], []), (o) => {
          const readableList = _.get(o, ['acl', 'readable'], []);
          return readableList.length < 1;
        }),
        highlighting: _.filter(_.get(res, ['highlighting'], []), (o) => {
          const readableList = _.get(o, ['acl', 'readable'], []);
          return readableList.length < 1;
        }),
      };
      console.log('cloneObjcloneObjcloneObjcloneObj', cloneObj);
      setSearchList(cloneObj);
      setSearching(false);
    });
  };

  return (
    <Container 
      maxWidth="xl"
      style={{ height: 'calc(100% - 30px)' }}>
      {/* 面包屑 */}
      {deviceType === 'computer' && <Breadcrumbs style={{ height: '30px' }} separator=">" maxItems={8}>
        <Link
          //   key={b.id}
          color='textPrimary'
          to={'/'}
          component={RouteLink}
        >
          首页
        </Link>
        {routers.length == 0 && <Typography color="textPrimary">
          资料下载
        </Typography>}
        {routers.length > 0 && <Link
          //   key={b.id}
          color='textPrimary'
          to={'/assets'}
          component={RouteLink}
        >
          资料下载
        </Link>}
        {routers.map((item, index) => {
          return <Link
            key={`router_${index}`}
            color='textPrimary'
            to={`/assets/${documents[item]?.id}`}
            component={RouteLink}
          >
            {documents[item]?.name}
          </Link>;
        })}
      </Breadcrumbs>}

      <Box className={classes.pages}>
        <Box 
          style={{ 
            width: deviceType === 'computer' ? '80%' : '100%', 
            paddingTop: deviceType === 'computer' ? '10px' : '0px', 
            paddingBottom: deviceType === 'computer' ? '16px' : '0px', 
            height: '100%', display: 'flex', flexDirection: 'column' 
          }}
        >
          {/* 标题 */}
          <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
            {deviceType === 'computer' && <Title name={'资料下载'}></Title>}
          </Box>
          {/* 搜索  模式切换BAR */}
          <Toolbar
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              // background: '#fff',
              padding: '0 12px',
              // margin: '-16px -16px 16px',
            }}
          >
            <Box style={{ marginRight: deviceType === 'computer' ? '6px' : 'auto' }}>
              <SearchInput  doSearch={doSearch} doCancel={doCancel} />
            </Box>
            {/* {deviceType === 'computer' && } */}
            <Box>
              {/* 大图 */}
              <IconButton 
                size='small' color={viewMode === 'picture'? 'primary': 'default'} 
                // disabled={viewMode === 'picture'} 
                onClick={() => {setViewMode('picture');}}>
                <ViewModule />
              </IconButton>
              {/* 小图 */}
              <IconButton size='small' color={viewMode === 'card'? 'primary': 'default'} 
                // disabled={viewMode === 'card'} 
                onClick={() => {setViewMode('card');}}>
                <ViewListIcon />
              </IconButton>
              {/* 列表 */}
              <IconButton size='small' color={viewMode === 'list'? 'primary': 'default'} 
                // disabled={viewMode === 'list'} 
                onClick={() => {setViewMode('list');}}>
                <Dehaze />
              </IconButton>
            </Box>
          </Toolbar>

          {/* 文件夹内容 */}
          {(!documents[id] || documents[id]?.type === 'folder')  &&  <Box
            style={{
              minHeight: 'calc(100vh - 300px)',
              flexGrow: '1', 
              // height: '0', 
              // background: 'white', 
              padding: documents[id]?.type === 'file' ? '0px' : '20px', 
              marginTop: deviceType === 'computer' ? '0' : '0px', 
              overflow: 'auto' 
            }}
          >
            {bSearch && <>
              <SearchPage 
                root='assets'
                data={searchList}
                // handleMenuClick={handleMenuClick}   // 显示菜单相关的事件，也不确定加不加
                // onOpen={onOpen}   //  埋点事件，先不加
              />
            </>}
            {!bSearch && <>
              {viewMode === 'picture' && <Grid
                container
                spacing={2}
                // spacing={ width === 'xs' ? 0 : 2 }
                direction="row"
              >
                {data.map(item => <Grid key={item.id}
                  item xs={6} sm={6} md={3}
                >
                  <PictureCard 
                    document={item} 
                    title={params.title}
                    bDownload={_.get(item, ['acl', 'downloadable'], true)} 
                    // isWarning={isWarning} 
                    onDownloadAction={(doc) => {
                      doDownload(doc);
                    }}
                    onMenuClick={() => console.log('e')} 
                    onClick={() => console.log('e')} 
                  />
                </Grid>)}
              </Grid>}
              {viewMode === 'card' && <Grid container spacing={2} direction="row">
                {data.map((item, index) => {
                  return (<Grid
                    item xs={6} sm={4} md={3} key={index}
                  >
                    <DocumentGridCard 
                      bDownload={_.get(item, ['acl', 'downloadable'], true)} 
                      document={item} 
                      isWarning={true} 
                      title={params.title} 
                      onMenuClick={() => console.log('e')} 
                      onDownloadAction={(doc) => {
                        doDownload(doc);
                      }}
                      onClick={(e, id) => {console.log({e, id});}} 
                    />
                  </Grid>);
                })}
              </Grid>}
              {viewMode === 'list' && <Grid container spacing={0} direction="row">
                {data.map((item, index) => {
                  return (<Grid
                    item xs={12} sm={12} md={12} key={index}
                  >
                    <DocumentGridList
                      bDownload={_.get(item, ['acl', 'downloadable'], true)} 
                      document={item} 
                      isWarning={true} 
                      title={params.title} 
                      onDownloadAction={(doc) => {
                        doDownload(doc);
                      }}
                      onMenuClick={() => console.log('eeeeeee')} 
                      onClick={(e, id) => console.log({e, id})} 
                    />
                  </Grid>);
                })}
              </Grid>}
              {/* 手机状态下 不单独区分 */}
              {false && deviceType !== 'computer' && <Grid container spacing={0} direction="row">
                {data.map((item, index) => {
                  return (<Grid
                    item xs={12} sm={12} md={12 } key={index}
                  >
                    <DocumentGridList
                      bDownload={_.get(item, ['acl', 'downloadable'], true)} 
                      document={item} 
                      isWarning={true} 
                      title={params.title} 
                      // onMenuClick={() => { }} 
                      onDownloadAction={(doc) => {
                        doDownload(doc);
                      }}
                      onClick={(e, id) => console.log({e, id})} 
                    />
                  </Grid>);
                })}
              </Grid>}
            </>}
          </Box>}









          {/* 之前的代码，先隐藏 */}
          {false && <Box style={{ flexGrow: '1', height: '0', background: 'white', padding: documents[id]?.type === 'file' ? '0px' : '20px', marginTop: deviceType === 'computer' ? '20px' : '0px', overflow: 'auto' }}>
            {(!documents[id] || documents[id]?.type === 'folder') && <Grid container spacing={2} direction="row">
              {data.map((item, index) => {
                return (<Grid
                  key={`dc_${index}`}
                  item xs={6} sm={4} md={3}
                >
                  <DocumentGridCard bDownload={true} document={item} isWarning={true} onMenuClick={() => { }} onClick={(e, id) => {
                    // history.push("/robot/outLibs?id="+id)
                  }} />
                </Grid>);
              })}

              {/* {documents.map(item => <Grid key={item.id}
                item xs={12} sm={4} md={3}
              >
                <DocumentGridCard document={item} isWarning={false} onMenuClick={()=>{}} onClick={()=>{}} />
              </Grid>)} */}
            </Grid>}

          </Box>}
          {(documents[id]&&(documents[id]?.type != 'folder')) && <Box style={{ backgroundColor: '#e5e5e', height: '100%' }}>
            <FileDocument 
              handleDownload={(document) => { 
                if ((!user)&&acl?.visitor_info?.length>0&&acl?.eoi.includes('download')) {
                  setIsLogining(true);
                  return;
                }
                dispatch(getTenantsIsLeadsInfoByphoneAction({ tenant:{id:webInfo.tnt_id}, user:{user, token}, phone:user?.phone})).then( async res => {
                  
                  setMustShow((!res.data) && (acl?.eoi?.includes('download')||acl?.eoi?.includes('view')));
                  if (!((!res.data) && (acl?.eoi?.includes('download')||acl?.eoi?.includes('view')))) {
                    //window.open(document.asset.url, "_blank");
                    // dispatch(userShareEvent({
                    //   user:{user:innerUser?.userId?{id:innerUser?.userId}:user}, 
                    //   share:{
                    //     tenantId:webInfo?.tnt_id,
                    //     id:'11111111-1111-1111-1111-111111111111',
                    //     memberId:innerUser?.memberId
                    //   }, 
                    //   document, 
                    //   type:'download', 
                    //   detail:null
                    // }));
                    sendEvent('download', document);
                    console.log('dowccc======', document);
                    DownloadFile(document?.asset?.url, document?.name+getFileSuffix(document?.name, document?.asset?.name), window, dispatch);

                  }
                });
              }}      
              document={documents[id]}
              user={{id:innerUser?.userId??user?.id, token:innerUser?.token??token}}
              share={null}
              eventID={eventID}
              onClose={() => { }}
              onLikeFormOpen={() => { }}
            />

          </Box>}
        </Box>
      </Box>
      {/* 登录弹框 */}
      {(!innerUser.userId)&&isLogining&&<Dialog
        open={isLogining}
        maxWidth='xs'
        // onClose={handleCloseForm}
      >
        <LoginForm 
          user={user}
          doSendCode={handleSendCode}
          share={{tenant:webInfo}}
          onSubmit={handleAuth}
          onClose={handleCloseLogin}
        />
      </Dialog>}
      {(!innerUser.userId) && !isEmpty(user) && !isNull(user) && mustShow && 
              <Dialog
                open={acl?.visitor_info?.length>0&&mustShow}
                maxWidth='xs'
              // onClose={handleCloseForm}
              >
                <LeadMustForm
                  share={{tenant:{...webInfo, info:{industries:webInfo.tnt_info.industries}}, required:acl?.required}}
                  user={user}
                  visitorInfo={acl?.visitor_info ?? []}
                  leadProfile={leadProfile}
                  doSendCode={handleSendCode}
                  onSubmit={(e) => {
                    // setSubmitResult(e)

                    handleAuthAndShareEvent(e);                    
                    if (acl.eoi.includes('download')) {
                      // SampleSendEvent(dispatch,userShareEvent,'download',documents[id]??selectDoc,null,getEventID(),innerUser?.userId?{id:innerUser?.userId}:user,{id:webInfo.tnt_id},innerUser?.memberId)
                      sendEvent('download', documents[id]??selectDoc);

                      DownloadFile(
                        documents[id]?.type==='file'?documents[id].asset.url:selectDoc?.asset?.url, (documents[id]?.type==='file'?documents[id]?.name:selectDoc?.name)+getFileSuffix(documents[id]?.type==='file'?documents[id]?.name:selectDoc?.name, documents[id]?.type==='file'?documents[id]?.asset?.name:selectDoc?.asset?.name), window, dispatch);

                    }

                  }}
                  onClose={() => {setMustShow(false);
                    if (acl?.eoi?.includes('view')&&documents[id]?.type==='file') {
                      history.goBack();
                    }
                  }}
                />
              
              </Dialog>
      }
    </Container>
  );
};


export default function FileDownloadContainer(props) {
  return (
    <FileDownloadView {...props} />
  );
}